export interface premiumVoice {
  languageCodes: string[];
  name: string;
  ssmlGender: string;
  naturalSampleRateHertz: number;
  humanName: string;
  short: string;
  language: string;
  text: string;
  url: string;
}

export const premiumVoices = [
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emma",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي إيما وسأكون الراوية اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Wavenet-A.mp3?generation=1620951004332779&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Liam",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي حسام وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Wavenet-B.mp3?generation=1620951006683257&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Noah",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي نوح وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Wavenet-C.mp3?generation=1620951009484762&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Olivia",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي أوليفيا وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Wavenet-D.mp3?generation=1620951012366654&alt=media",
  },
  {
    languageCodes: ["bn-IN"],
    name: "bn-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ava",
    short: "bn",
    language: "Bengali (India)",
    text: "\nহ্যালো আমার নাম আভা এবং আমি আজ আপনার বর্ণনাকারী হব।\nঅডিও যে কোনও কিছুই স্পিচ সফ্টওয়্যারগুলির জন্য নিখরচায় পাঠ্য\nকৃত্রিম বুদ্ধিমত্তা এবং মেশিন লার্নিং উত্পন্ন করতে\nখাঁটি মানব কণ্ঠস্বর। এটি ওভারে পাঠ্য থেকে স্পিচ সমর্থন করে\n200 ভয়েস এবং 40 এরও বেশি ভাষা!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/bn-IN-Wavenet-A.mp3?generation=1620951016006179&alt=media",
  },
  {
    languageCodes: ["bn-IN"],
    name: "bn-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "William",
    short: "bn",
    language: "Bengali (India)",
    text: "\nহ্যালো আমার নাম উইলিয়াম এবং আমি আজ আপনার বর্ণনাকারী হব।\nঅডিও যে কোনও কিছুই স্পিচ সফ্টওয়্যারগুলির জন্য নিখরচায় পাঠ্য\nকৃত্রিম বুদ্ধিমত্তা এবং মেশিন লার্নিং উত্পন্ন করতে\nখাঁটি মানব কণ্ঠস্বর। এটি ওভারে পাঠ্য থেকে স্পিচ সমর্থন করে\n200 ভয়েস এবং 40 এরও বেশি ভাষা!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/bn-IN-Wavenet-B.mp3?generation=1620951018936712&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isabella",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Isabella and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Wavenet-A.mp3?generation=1620951021811806&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "James",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is James and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Wavenet-B.mp3?generation=1620951024943820&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sophia",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Sophia and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Wavenet-C.mp3?generation=1620951027734567&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Oliver",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Oliver and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Wavenet-D.mp3?generation=1620951030621404&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Wavenet-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Charlotte",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Charlotte and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Wavenet-F.mp3?generation=1620951033406009&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mia",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Mia et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Wavenet-A.mp3?generation=1620951036191936&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Benjamin",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Benjamin et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Wavenet-B.mp3?generation=1620951038941256&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Amelia",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Amelia et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Wavenet-C.mp3?generation=1620951041780425&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Elijah",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Elijah et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Wavenet-D.mp3?generation=1620951044600869&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-G",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Harper",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Harper and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-G.mp3?generation=1620951047415678&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-H",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Evelyn",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Evelyn and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-H.mp3?generation=1620951050362510&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-I",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lucas",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Lucas and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-I.mp3?generation=1620951053282606&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-J",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mason",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Mason and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-J.mp3?generation=1620951056139166&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-A",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Logan",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Logan and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-A.mp3?generation=1620951059086780&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alexander",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Alexander and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-B.mp3?generation=1620951061916644&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Abigail",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Abigail and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-C.mp3?generation=1620951064666745&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ethan",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Ethan and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-D.mp3?generation=1620951067512596&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emily",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Emily and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-E.mp3?generation=1620951070259362&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Wavenet-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Elizabeth",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Elizabeth and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Wavenet-F.mp3?generation=1620951072939167&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mila",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola mi nombre es Mila y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Wavenet-C.mp3?generation=1620951075760521&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ella",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Ella y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Wavenet-D.mp3?generation=1620951078473396&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jacob",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Jacob y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Wavenet-B.mp3?generation=1620951081371552&alt=media",
  },
  {
    languageCodes: ["fi-FI"],
    name: "fi-FI-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Avery",
    short: "fi",
    language: "Finnish (Finland)",
    text: "\nHei, nimeni on Avery ja minä olen sinun kertojasi tänään.\nAudio Anything on ilmainen tekstistä puheeksi -ohjelmisto, joka käyttää\nTekoäly ja koneoppiminen tuottamaan\naitoja ihmisen ääniä. Se tukee teksti puheeksi -ohjelmaa\n200 ääntä ja yli 40 kieltä!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fi-FI-Wavenet-A.mp3?generation=1620951083996327&alt=media",
  },
  {
    languageCodes: ["gu-IN"],
    name: "gu-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sofia",
    short: "gu",
    language: "Gujarati (India)",
    text: "\nનમસ્તે મારું નામ સોફિયા છે અને હું આજે તમારો નારેટર બનીશ.\nAudioડિઓ કંઈપણ એ સ્પીચ સ softwareફ્ટવેરનો મફત ટેક્સ્ટ છે જેનો ઉપયોગ કરે છે\nકૃત્રિમ બુદ્ધિ અને ઉત્પાદન શીખવા માટે મશીન\nઅધિકૃત માનવ અવાજો. તે ઓવરમાં ટેક્સ્ટ ટુ સ્પીચને સપોર્ટ કરે છે\n200 અવાજો અને 40 થી વધુ ભાષાઓ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/gu-IN-Wavenet-A.mp3?generation=1620951087120691&alt=media",
  },
  {
    languageCodes: ["gu-IN"],
    name: "gu-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Michael",
    short: "gu",
    language: "Gujarati (India)",
    text: "\nનમસ્તે મારું નામ માઇકલ છે અને હું આજે તમારો નેરેટર બનીશ.\nAudioડિઓ કંઈપણ એ સ્પીચ સ softwareફ્ટવેરનો મફત ટેક્સ્ટ છે જેનો ઉપયોગ કરે છે\nકૃત્રિમ બુદ્ધિ અને ઉત્પાદન શીખવા માટે મશીન\nઅધિકૃત માનવ અવાજો. તે ઓવરમાં ટેક્સ્ટ ટુ સ્પીચને સપોર્ટ કરે છે\n200 અવાજો અને 40 થી વધુ ભાષાઓ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/gu-IN-Wavenet-B.mp3?generation=1620951090365177&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Wavenet-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Camila",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はカミラです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Wavenet-B.mp3?generation=1620951093053985&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Daniel",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はダニエルです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Wavenet-C.mp3?generation=1620951095893726&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Henry",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はヘンリーです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Wavenet-D.mp3?generation=1620951098699504&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aria",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はアリアです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Wavenet-A.mp3?generation=1620951101428467&alt=media",
  },
  {
    languageCodes: ["kn-IN"],
    name: "kn-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Scarlett",
    short: "kn",
    language: "Kannada (India)",
    text: "\nಹಲೋ ನನ್ನ ಹೆಸರು ಸ್ಕಾರ್ಲೆಟ್ ಮತ್ತು ನಾನು ಇಂದು ನಿಮ್ಮ ನಿರೂಪಕನಾಗುತ್ತೇನೆ.\nಆಡಿಯೋ ಎನಿಥಿಂಗ್ ಎನ್ನುವುದು ಸ್ಪೀಚ್ ಸಾಫ್ಟ್‌ವೇರ್‌ಗೆ ಬಳಸುವ ಉಚಿತ ಪಠ್ಯವಾಗಿದೆ\nಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಮತ್ತು ಉತ್ಪಾದಿಸಲು ಯಂತ್ರ ಕಲಿಕೆ\nಅಧಿಕೃತ ಮಾನವ ಧ್ವನಿಗಳು. ಇದು ಪಠ್ಯದಿಂದ ಭಾಷಣವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ\n200 ಧ್ವನಿಗಳು ಮತ್ತು 40 ಕ್ಕೂ ಹೆಚ್ಚು ಭಾಷೆಗಳು!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/kn-IN-Wavenet-A.mp3?generation=1620951104566641&alt=media",
  },
  {
    languageCodes: ["kn-IN"],
    name: "kn-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jackson",
    short: "kn",
    language: "Kannada (India)",
    text: "\nಹಲೋ ನನ್ನ ಹೆಸರು ಜಾಕ್ಸನ್ ಮತ್ತು ನಾನು ಇಂದು ನಿಮ್ಮ ನಿರೂಪಕನಾಗುತ್ತೇನೆ.\nಆಡಿಯೋ ಎನಿಥಿಂಗ್ ಎನ್ನುವುದು ಸ್ಪೀಚ್ ಸಾಫ್ಟ್‌ವೇರ್‌ಗೆ ಬಳಸುವ ಉಚಿತ ಪಠ್ಯವಾಗಿದೆ\nಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಮತ್ತು ಉತ್ಪಾದಿಸಲು ಯಂತ್ರ ಕಲಿಕೆ\nಅಧಿಕೃತ ಮಾನವ ಧ್ವನಿಗಳು. ಇದು ಪಠ್ಯದಿಂದ ಭಾಷಣವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ\n200 ಧ್ವನಿಗಳು ಮತ್ತು 40 ಕ್ಕೂ ಹೆಚ್ಚು ಭಾಷೆಗಳು!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/kn-IN-Wavenet-B.mp3?generation=1620951107618405&alt=media",
  },
  {
    languageCodes: ["ml-IN"],
    name: "ml-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Victoria",
    short: "ml",
    language: "Malayalam (India)",
    text: "\nഹലോ എന്റെ പേര് വിക്ടോറിയ, ഞാൻ ഇന്ന് നിങ്ങളുടെ ആഖ്യാതാവ് ആയിരിക്കും.\nസംഭാഷണ സോഫ്റ്റ്വെയറിലേക്കുള്ള ഒരു സ text ജന്യ വാചകമാണ് ഓഡിയോ എന്തും\nസൃഷ്ടിക്കുന്നതിനുള്ള കൃത്രിമ ഇന്റലിജൻസ്, മെഷീൻ ലേണിംഗ്\nആധികാരിക മനുഷ്യ ശബ്ദങ്ങൾ. ഇത് ടെക്സ്റ്റ് ടു സ്പീച്ച് ഓവർ പിന്തുണയ്ക്കുന്നു\n200 ശബ്ദങ്ങളും 40 ലധികം ഭാഷകളും!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ml-IN-Wavenet-A.mp3?generation=1620951110244911&alt=media",
  },
  {
    languageCodes: ["ml-IN"],
    name: "ml-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sebastian",
    short: "ml",
    language: "Malayalam (India)",
    text: "\nഹലോ എന്റെ പേര് സെബാസ്റ്റ്യൻ, ഞാൻ ഇന്ന് നിങ്ങളുടെ ആഖ്യാതാവ് ആയിരിക്കും.\nസംഭാഷണ സോഫ്റ്റ്വെയറിലേക്കുള്ള ഒരു സ text ജന്യ വാചകമാണ് ഓഡിയോ എന്തും\nസൃഷ്ടിക്കുന്നതിനുള്ള കൃത്രിമ ഇന്റലിജൻസ്, മെഷീൻ ലേണിംഗ്\nആധികാരിക മനുഷ്യ ശബ്ദങ്ങൾ. ഇത് ടെക്സ്റ്റ് ടു സ്പീച്ച് ഓവർ പിന്തുണയ്ക്കുന്നു\n200 ശബ്ദങ്ങളും 40 ലധികം ഭാഷകളും!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ml-IN-Wavenet-B.mp3?generation=1620951113121798&alt=media",
  },
  {
    languageCodes: ["sv-SE"],
    name: "sv-SE-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Madison",
    short: "sv",
    language: "Swedish (Sweden)",
    text: "\nHej jag heter Madison och jag kommer att vara din narrator idag.\nAudio Anything är en fri-till-tal-programvara som använder\nArtificiell intelligens och maskininlärning att generera\nautentiska mänskliga röster. Den stöder Text to Speech över\n200 röster och över 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/sv-SE-Wavenet-A.mp3?generation=1620951115688421&alt=media",
  },
  {
    languageCodes: ["ta-IN"],
    name: "ta-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Luna",
    short: "ta",
    language: "Tamil (India)",
    text: "\nவணக்கம் என் பெயர் லூனா, நான் இன்று உங்கள் கதைசொல்லியாக இருப்பேன்.\nஆடியோ எதையும் பேச்சு மென்பொருளுக்கு இலவச உரை\nஉருவாக்க செயற்கை நுண்ணறிவு மற்றும் இயந்திர கற்றல்\nஉண்மையான மனித குரல்கள். இது உரையில் இருந்து பேச்சுக்கு துணைபுரிகிறது\n200 குரல்கள் மற்றும் 40 க்கும் மேற்பட்ட மொழிகள்!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ta-IN-Wavenet-A.mp3?generation=1620951118357126&alt=media",
  },
  {
    languageCodes: ["ta-IN"],
    name: "ta-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aiden",
    short: "ta",
    language: "Tamil (India)",
    text: "\nவணக்கம் என் பெயர் ஐடன், நான் இன்று உங்கள் கதைசொல்லியாக இருப்பேன்.\nஆடியோ எதையும் பேச்சு மென்பொருளுக்கு இலவச உரை\nஉருவாக்க செயற்கை நுண்ணறிவு மற்றும் இயந்திர கற்றல்\nஉண்மையான மனித குரல்கள். இது உரையில் இருந்து பேச்சுக்கு துணைபுரிகிறது\n200 குரல்கள் மற்றும் 40 க்கும் மேற்பட்ட மொழிகள்!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ta-IN-Wavenet-B.mp3?generation=1620951121145049&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Matthew",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Matthew ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Wavenet-B.mp3?generation=1620951123829595&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Grace",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Grace ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Wavenet-C.mp3?generation=1620951126465249&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Chloe",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Chloe ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Wavenet-D.mp3?generation=1620951129088734&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Wavenet-E",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Samuel",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba, benim adım Samuel ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Wavenet-E.mp3?generation=1620951131705484&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Penelope",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Penelope ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Wavenet-A.mp3?generation=1620951134385760&alt=media",
  },
  {
    languageCodes: ["cs-CZ"],
    name: "cs-CZ-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Layla",
    short: "cs",
    language: "Czech (Czech Republic)",
    text: "\nDobrý den, jmenuji se Layla a budu dnes vaším vypravěčem.\nAudio Anything je bezplatný software pro převod textu na řeč, který používá\nGenerování umělé inteligence a strojového učení\nautentické lidské hlasy. Podporuje převod textu na řeč\n200 hlasů a více než 40 jazyků!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cs-CZ-Wavenet-A.mp3?generation=1620951137119868&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Riley",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Riley und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-F.mp3?generation=1620951139897148&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Zoey",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Zoey und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-A.mp3?generation=1620951142839007&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "David",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist David und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-B.mp3?generation=1620951145609528&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nora",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Nora und ich werde heute Ihre Erzählerin sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-C.mp3?generation=1620951148504235&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Joseph",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Joseph und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-D.mp3?generation=1620951151398192&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Wavenet-E",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Carter",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Carter und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Wavenet-E.mp3?generation=1620951154242463&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lily",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Lily and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Wavenet-A.mp3?generation=1620951157040509&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Owen",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Owen and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Wavenet-B.mp3?generation=1620951159845117&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eleanor",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Eleanor and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Wavenet-C.mp3?generation=1620951162594010&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Wyatt",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Wyatt and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Wavenet-D.mp3?generation=1620951165273941&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hannah",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Hannah and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Wavenet-D.mp3?generation=1620951168168111&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lillian",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Lillian and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Wavenet-A.mp3?generation=1620951171418405&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "John",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is John and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Wavenet-B.mp3?generation=1620951174406716&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jack",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Jack and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Wavenet-C.mp3?generation=1620951177433483&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Addison",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola, mi nombre es Addison y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Wavenet-A.mp3?generation=1620951180189226&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Luke",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola, mi nombre es Luke y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Wavenet-B.mp3?generation=1620951182879500&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jayden",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola, mi nombre es Jayden y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Wavenet-C.mp3?generation=1620951186368174&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aubrey",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Aubrey et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Wavenet-E.mp3?generation=1620951189084069&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ellie",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Ellie et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Wavenet-A.mp3?generation=1620951191812666&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Dylan",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Dylan et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Wavenet-B.mp3?generation=1620951194499577&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Stella",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Stella et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Wavenet-C.mp3?generation=1620951197380852&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Grayson",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Grayson et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Wavenet-D.mp3?generation=1620951200211061&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Natalie",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्ते मेरा नाम नताली है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Wavenet-D.mp3?generation=1620951203381571&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Zoe",
    short: "hi",
    language: "Hindi (India)",
    text: "\nहैलो मेरा नाम ज़ो है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Wavenet-A.mp3?generation=1620951206745124&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Levi",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्कार मेरा नाम लेवी है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Wavenet-B.mp3?generation=1620951209748449&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isaac",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्ते मेरा नाम इसहाक है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Wavenet-C.mp3?generation=1620951212822542&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Leah",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Leah dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Wavenet-D.mp3?generation=1620951215549495&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hazel",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Hazel dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Wavenet-A.mp3?generation=1620951218292549&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Gabriel",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Gabriel dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Wavenet-B.mp3?generation=1620951220973907&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Julian",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Julian dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Wavenet-C.mp3?generation=1620951223651008&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Violet",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Violet e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Wavenet-A.mp3?generation=1620951226384296&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Wavenet-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aurora",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Aurora e oggi sarò la tua narratrice.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Wavenet-B.mp3?generation=1620951229023965&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mateo",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Mateo e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Wavenet-C.mp3?generation=1620951231685133&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Anthony",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Anthony e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Wavenet-D.mp3?generation=1620951234378233&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Savannah",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요, 제 이름은 Savannah입니다. 오늘 저는 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Wavenet-A.mp3?generation=1620951237085468&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Wavenet-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Audrey",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요 제 이름은 오드리입니다. 오늘 제가 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Wavenet-B.mp3?generation=1620951240200319&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jaxon",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요, 제 이름은 Jaxon이고 오늘 제가 당신의 화자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Wavenet-C.mp3?generation=1620951242890004&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lincoln",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요 제 이름은 링컨입니다. 오늘 제가 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Wavenet-D.mp3?generation=1620951245615153&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Brooklyn",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Бруклин, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Wavenet-E.mp3?generation=1620951248526561&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Bella",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Белла, и я буду вашим рассказчиком сегодня.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Wavenet-A.mp3?generation=1620951251371872&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Joshua",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Джошуа, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Wavenet-B.mp3?generation=1620951254392834&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Claire",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Клэр, и я буду вашим рассказчиком сегодня.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Wavenet-C.mp3?generation=1620951257283444&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Christopher",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Кристофер, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Wavenet-D.mp3?generation=1620951260401996&alt=media",
  },
  {
    languageCodes: ["uk-UA"],
    name: "uk-UA-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Skylar",
    short: "uk",
    language: "Ukrainian (Ukraine)",
    text: "\nПривіт, мене звуть Скайлар, і сьогодні я буду вашим оповідачем.\nAudio Anything - це безкоштовне програмне забезпечення для перетворення тексту в мову, яке використовує\nШтучний інтелект та машинне навчання для створення\nсправжні людські голоси. Він підтримує перетворення тексту в мову\n200 голосів і понад 40 мов!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/uk-UA-Wavenet-A.mp3?generation=1620951263175580&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lucy",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫露西（Lucy），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Wavenet-A.mp3?generation=1620951265913293&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Andrew",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫安德鲁（Andrew），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Wavenet-B.mp3?generation=1620951268557087&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Theodore",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫西奥多（Theodore），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Wavenet-C.mp3?generation=1620951271436834&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Paisley",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫佩斯利（Paisley），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Wavenet-D.mp3?generation=1620951274132111&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Everly",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫Everly，今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Wavenet-A.mp3?generation=1620951276838536&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Caleb",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫Caleb，今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Wavenet-B.mp3?generation=1620951279581153&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ryan",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫瑞安（Ryan），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Wavenet-C.mp3?generation=1620951282278517&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Asher",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Asher, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Wavenet-C.mp3?generation=1620951284909153&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Anna",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Anna, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Wavenet-D.mp3?generation=1620951287688323&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Caroline",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Caroline, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Wavenet-E.mp3?generation=1620951290425542&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nova",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Nova, og jeg bliver din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Wavenet-A.mp3?generation=1620951293113043&alt=media",
  },
  {
    languageCodes: ["el-GR"],
    name: "el-GR-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Genesis",
    short: "el",
    language: "Greek (Greece)",
    text: "\nΓεια σας, το όνομά μου είναι Genesis και θα γίνω ο αφηγητής σας σήμερα.\nΤο Audio Anything είναι ένα δωρεάν λογισμικό κειμένου σε ομιλία που χρησιμοποιεί\nΤεχνητή νοημοσύνη και μηχανική μάθηση για δημιουργία\nαυθεντικές ανθρώπινες φωνές. Υποστηρίζει κείμενο σε ομιλία\n200 φωνές και πάνω από 40 γλώσσες!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/el-GR-Wavenet-A.mp3?generation=1620951295726364&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emilia",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang pangalan ko ay Emilia at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Wavenet-A.mp3?generation=1620951298639111&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Wavenet-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kennedy",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang pangalan ko ay Kennedy at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Wavenet-B.mp3?generation=1620951301503315&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nathan",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang pangalan ko ay Nathan at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Wavenet-C.mp3?generation=1620951304262097&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Thomas",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang aking pangalan ay Thomas at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Wavenet-D.mp3?generation=1620951307016717&alt=media",
  },
  {
    languageCodes: ["hu-HU"],
    name: "hu-HU-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Samantha",
    short: "hu",
    language: "Hungarian (Hungary)",
    text: "\nHelló, Samantha vagyok, és ma leszek a narrátorod.\nAz Audio Anything egy ingyenes szövegfelolvasó szoftver, amelyet használ\nMesterséges intelligencia és gépi tanulás generálni\nhiteles emberi hangok. Támogatja a szövegfelolvasást\n200 hang és több mint 40 nyelv!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hu-HU-Wavenet-A.mp3?generation=1620951309717911&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Maya",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Maya, og jeg blir din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Wavenet-A.mp3?generation=1620951312337325&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Leo",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Leo, og jeg blir narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Wavenet-B.mp3?generation=1620951314971502&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Willow",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Willow, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Wavenet-C.mp3?generation=1620951317657931&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isaiah",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Isaiah, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Wavenet-D.mp3?generation=1620951320395938&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-no-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kinsley",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Kinsley, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-no-Wavenet-E.mp3?generation=1620951323005235&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Charles",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Charles en ik zal vandaag uw verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Wavenet-B.mp3?generation=1620951325760994&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Josiah",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Josiah en ik zal vandaag uw verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Wavenet-C.mp3?generation=1620951328561560&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Naomi",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Naomi en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Wavenet-D.mp3?generation=1620951331327566&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aaliyah",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Aaliyah en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Wavenet-A.mp3?generation=1620951334137952&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Elena",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Elena en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Wavenet-E.mp3?generation=1620951336972478&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sarah",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Sarah e eu serei sua narradora hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Wavenet-A.mp3?generation=1620951339667514&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hudson",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Hudson e serei seu narrador hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Wavenet-B.mp3?generation=1620951343130602&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Christian",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é cristão e serei seu narrador hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Wavenet-C.mp3?generation=1620951345996180&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ariana",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Ariana e hoje serei sua narradora.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Wavenet-D.mp3?generation=1620951348668554&alt=media",
  },
  {
    languageCodes: ["sk-SK"],
    name: "sk-SK-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Allison",
    short: "sk",
    language: "Slovak (Slovakia)",
    text: "\nDobrý deň, volám sa Allison a budem dnes vaším rozprávačom.\nAudio Anything je bezplatný softvér na prevod textu na reč, ktorý používa\nUmelá inteligencia a strojové učenie sa generovať\nautentické ľudské hlasy. Podporuje prevod textu na reč\n200 hlasov a viac ako 40 jazykov!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/sk-SK-Wavenet-A.mp3?generation=1620951351300037&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Gabriella",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Gabriella và tôi sẽ là người kể chuyện của bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Wavenet-A.mp3?generation=1620951354060511&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hunter",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Hunter và tôi sẽ là người kể chuyện cho bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Wavenet-B.mp3?generation=1620951357174883&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Wavenet-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alice",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Alice và tôi sẽ là người kể chuyện của bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Wavenet-C.mp3?generation=1620951359860837&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Wavenet-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Connor",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Connor và tôi sẽ là người kể chuyện cho bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Wavenet-D.mp3?generation=1620951362548761&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Madelyn",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Madelyn i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Wavenet-A.mp3?generation=1620951365299834&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Wavenet-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eli",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Eli i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Wavenet-B.mp3?generation=1620951368052392&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Wavenet-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ezra",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Ezra i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Wavenet-C.mp3?generation=1620951370855812&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Wavenet-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Cora",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Cora i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Wavenet-E.mp3?generation=1620951373508651&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Wavenet-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ruby",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nCześć, nazywam się Ruby i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Wavenet-D.mp3?generation=1620951376243369&alt=media",
  },
  {
    languageCodes: ["pt-BR"],
    name: "pt-BR-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eva",
    short: "pt",
    language: "Portuguese (Brazil)",
    text: "\nOlá, meu nome é Eva e hoje serei sua narradora.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-BR-Wavenet-A.mp3?generation=1620951379124898&alt=media",
  },
  {
    languageCodes: ["ca-ES"],
    name: "ca-es-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Serenity",
    short: "ca",
    language: "Catalan (Spain)",
    text: "\nHola em dic Serenity i seré el vostre narrador avui.\nAudio Anything és un programari gratuït que utilitza text a veu\nIntel·ligència artificial i aprenentatge automàtic per generar\nautèntiques veus humanes. Admet text a veu en excés\n200 veus i més de 40 idiomes.\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ca-es-Standard-A.mp3?generation=1620951381811730&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Autumn",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Autumn y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Standard-C.mp3?generation=1620951384618945&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Adeline",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Adeline y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Standard-D.mp3?generation=1620951387506329&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aaron",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Aaron y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Standard-B.mp3?generation=1620951390311870&alt=media",
  },
  {
    languageCodes: ["es-ES"],
    name: "es-ES-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hailey",
    short: "es",
    language: "Spanish (Spain)",
    text: "\nHola, mi nombre es Hailey y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-ES-Standard-A.mp3?generation=1620951393078208&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-A",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Landon",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Landon and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-A.mp3?generation=1620951395849534&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Adrian",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Adrian and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-B.mp3?generation=1620951398562158&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Gianna",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Gianna and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-C.mp3?generation=1620951401394956&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jonathan",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Jonathan and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-D.mp3?generation=1620951404120286&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Valentina",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Valentina and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-E.mp3?generation=1620951406847076&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isla",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Isla and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-F.mp3?generation=1620951409597545&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-G",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eliana",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Eliana and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-G.mp3?generation=1620951412534628&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-H",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Quinn",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Quinn and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-H.mp3?generation=1620951415402654&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-I",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nolan",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Nolan and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-I.mp3?generation=1620951418236183&alt=media",
  },
  {
    languageCodes: ["en-US"],
    name: "en-US-Standard-J",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jeremiah",
    short: "en",
    language: "English (US)",
    text: "\nHello my name is Jeremiah and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-US-Standard-J.mp3?generation=1620951421113630&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nevaeh",
    short: "ar",
    language: "Arabic",
    text: "\nمرحبا اسمي نفاع وسأكون الراوية اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Standard-A.mp3?generation=1620951424032836&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Easton",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي إيستون وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Standard-B.mp3?generation=1620951426780721&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Elias",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً اسمي إلياس وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Standard-C.mp3?generation=1620951429685785&alt=media",
  },
  {
    languageCodes: ["ar-XA"],
    name: "ar-XA-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ivy",
    short: "ar",
    language: "Arabic",
    text: "\nمرحباً ، اسمي آيفي وسأكون الراوي اليوم.\nالصوت أي شيء هو برنامج نصي إلى كلام مجاني يستخدمه\nإنشاء الذكاء الاصطناعي وتعلم الآلة\nأصوات بشرية أصيلة. وهو يدعم تحويل النص إلى كلام في أكثر من\n200 صوت وأكثر من 40 لغة!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ar-XA-Standard-D.mp3?generation=1620951432479229&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sadie",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Sadie et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Standard-E.mp3?generation=1620951435240392&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Piper",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Piper e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Standard-A.mp3?generation=1620951438049353&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lydia",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Лидия, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Standard-E.mp3?generation=1620951440899612&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alexa",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Алекса, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Standard-A.mp3?generation=1620951443986218&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Colton",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Колтон, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Standard-B.mp3?generation=1620951446896750&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Josephine",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Жозефина, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Standard-C.mp3?generation=1620951449765868&alt=media",
  },
  {
    languageCodes: ["ru-RU"],
    name: "ru-RU-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Cameron",
    short: "ru",
    language: "Russian (Russia)",
    text: "\nЗдравствуйте, меня зовут Кэмерон, и сегодня я буду вашим рассказчиком.\nAudio Anything - это бесплатное программное обеспечение для преобразования текста в речь, которое использует\nИскусственный интеллект и машинное обучение для создания\nподлинные человеческие голоса. Он поддерживает преобразование текста в речь в более чем\n200 голосов и более 40 языков!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ru-RU-Standard-D.mp3?generation=1620951452769315&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Carson",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫卡森（Carson），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Standard-C.mp3?generation=1620951455541536&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Robert",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫罗伯特（Robert），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Standard-B.mp3?generation=1620951458270883&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emery",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫埃默里（Emery），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Standard-A.mp3?generation=1620951460966750&alt=media",
  },
  {
    languageCodes: ["cmn-CN"],
    name: "cmn-CN-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Julia",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫朱莉娅（Julia），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-CN-Standard-D.mp3?generation=1620951463650773&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Delilah",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はデリラです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Standard-A.mp3?generation=1620951466487991&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Standard-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Arianna",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はアリアナです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Standard-B.mp3?generation=1620951469256332&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Angel",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はエンジェルです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Standard-C.mp3?generation=1620951471985463&alt=media",
  },
  {
    languageCodes: ["ja-JP"],
    name: "ja-JP-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Maverick",
    short: "ja",
    language: "Japanese (Japan)",
    text: "\nこんにちは私の名前はマーベリックです。今日はあなたのナラレーターになります。\nAudio Anythingは、を使用する無料のテキスト読み上げソフトウェアです。\n生成する人工知能と機械学習\n本物の人間の声。それは以上のテキスト読み上げをサポートします\n200の声と40以上の言語！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ja-JP-Standard-D.mp3?generation=1620951474761194&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Vivian",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫Vivian，今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Standard-A.mp3?generation=1620951477592226&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nicholas",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫尼古拉斯（Nicholas），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Standard-B.mp3?generation=1620951480330106&alt=media",
  },
  {
    languageCodes: ["cmn-TW"],
    name: "cmn-TW-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Dominic",
    short: "cmn",
    language: "Mandarin Chinese",
    text: "\n您好，我叫多米尼克（Dominic），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cmn-TW-Standard-C.mp3?generation=1620951483070128&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Standard-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kaylee",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요 제 이름은 Kaylee이며 오늘 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Standard-B.mp3?generation=1620951485814614&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jaxson",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요, 제 이름은 Jaxson이고 오늘 저는 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Standard-C.mp3?generation=1620951488540656&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Greyson",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요, 제 이름은 그레이슨입니다. 오늘 저는 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Standard-D.mp3?generation=1620951491174704&alt=media",
  },
  {
    languageCodes: ["ko-KR"],
    name: "ko-KR-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sophie",
    short: "ko",
    language: "Korean (South Korea)",
    text: "\n안녕하세요, 제 이름은 Sophie이고 오늘은 당신의 해설자가 될 것입니다.\nAudio Anything은 다음을 사용하는 무료 텍스트 음성 변환 소프트웨어입니다.\n생성 할 인공 지능 및 기계 학습\n진정한 인간의 목소리. 그것은 텍스트 음성 변환을 지원합니다\n200 개의 음성과 40 개 이상의 언어!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ko-KR-Standard-A.mp3?generation=1620951493875717&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Brielle",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tên tôi là Brielle và tôi sẽ là người kể chuyện của bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Standard-A.mp3?generation=1620951496687910&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Adam",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Adam và tôi sẽ là người kể chuyện cho bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Standard-B.mp3?generation=1620951499483119&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Madeline",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tôi tên là Madeline và tôi sẽ là người kể chuyện của bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Standard-C.mp3?generation=1620951502292559&alt=media",
  },
  {
    languageCodes: ["vi-VN"],
    name: "vi-VN-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ian",
    short: "vi",
    language: "Vietnamese (Vietnam)",
    text: "\nXin chào, tên tôi là Ian và tôi sẽ là người kể chuyện của bạn hôm nay.\nAudio Anything là một phần mềm chuyển văn bản thành giọng nói miễn phí sử dụng\nTrí tuệ nhân tạo và Máy học để tạo\ntiếng nói đích thực của con người. Nó hỗ trợ Text to Speech trong hơn\n200 giọng nói và hơn 40 ngôn ngữ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/vi-VN-Standard-D.mp3?generation=1620951504969771&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Peyton",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Peyton dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Standard-A.mp3?generation=1620951507720269&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Austin",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Austin dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Standard-B.mp3?generation=1620951510598009&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Santiago",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Santiago dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Standard-C.mp3?generation=1620951513317470&alt=media",
  },
  {
    languageCodes: ["id-ID"],
    name: "id-ID-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Rylee",
    short: "id",
    language: "Indonesian (Indonesia)",
    text: "\nHalo nama saya Rylee dan saya akan menjadi narator Anda hari ini.\nAudio Anything adalah perangkat lunak text to speech gratis yang menggunakan\nKecerdasan Buatan dan Pembelajaran Mesin untuk menghasilkan\nsuara manusia yang otentik. Ini mendukung Text to Speech di lebih\n200 suara dan lebih dari 40 bahasa!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/id-ID-Standard-D.mp3?generation=1620951516212939&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jordan",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Jordan en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Standard-B.mp3?generation=1620951518924777&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Cooper",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Cooper en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Standard-C.mp3?generation=1620951521698065&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Clara",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Clara en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Standard-D.mp3?generation=1620951524439069&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Hadley",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Hadley en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Standard-E.mp3?generation=1620951527132663&alt=media",
  },
  {
    languageCodes: ["nl-NL"],
    name: "nl-NL-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Melanie",
    short: "nl",
    language: "Dutch (Netherlands)",
    text: "\nHallo, mijn naam is Melanie en ik zal vandaag je verteller zijn.\nAudio Anything is een gratis tekst-naar-spraak-software die gebruikmaakt van\nKunstmatige intelligentie en machine learning om te genereren\nauthentieke menselijke stemmen. Het ondersteunt tekst-naar-spraak in over\n200 stemmen en meer dan 40 talen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nl-NL-Standard-A.mp3?generation=1620951529871441&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Standard-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mackenzie",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang pangalan ko ay Mackenzie at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Standard-B.mp3?generation=1620951532698728&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Brayden",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang pangalan ko ay Brayden at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Standard-C.mp3?generation=1620951535555134&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Roman",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang aking pangalan ay Roman at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Standard-D.mp3?generation=1620951538453154&alt=media",
  },
  {
    languageCodes: ["fil-PH"],
    name: "fil-PH-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Reagan",
    short: "fil",
    language: "Filipino (Philippines)",
    text: "\nKumusta ang aking pangalan ay Reagan at ako ang magiging tagapagsalaysay mo ngayon.\nAng Audio Anything ay isang libreng text to software ng software na gumagamit\nArtipisyal na Katalinuhan at Pag-aaral ng Makina upang makabuo\ntunay na boses ng tao. Sinusuportahan nito ang Teksto sa Pagsasalita nang tapos na\n200 mga tinig at higit sa 40 mga wika!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fil-PH-Standard-A.mp3?generation=1620951541245348&alt=media",
  },
  {
    languageCodes: ["yue-HK"],
    name: "yue-HK-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Adalynn",
    short: "yue",
    language: "Chinese (Hong Kong)",
    text: "\n您好，我叫Adalynn，今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/yue-HK-Standard-A.mp3?generation=1620951544099400&alt=media",
  },
  {
    languageCodes: ["yue-HK"],
    name: "yue-HK-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Evan",
    short: "yue",
    language: "Chinese (Hong Kong)",
    text: "\n您好，我叫埃文（Evan），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/yue-HK-Standard-B.mp3?generation=1620951546867069&alt=media",
  },
  {
    languageCodes: ["yue-HK"],
    name: "yue-HK-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Liliana",
    short: "yue",
    language: "Chinese (Hong Kong)",
    text: "\n您好，我叫莉莉安娜（Liliana），今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/yue-HK-Standard-C.mp3?generation=1620951549684370&alt=media",
  },
  {
    languageCodes: ["yue-HK"],
    name: "yue-HK-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ezekiel",
    short: "yue",
    language: "Chinese (Hong Kong)",
    text: "\n您好，我叫以西结，今天我将成为您的叙述者。\nAudio Anything是使用以下内容的免费文本到语音软件\n人工智能和机器学习生成\n真实的人类声音。它支持文字转语音\n200种声音和40多种语言！\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/yue-HK-Standard-D.mp3?generation=1620951552511150&alt=media",
  },
  {
    languageCodes: ["cs-CZ"],
    name: "cs-CZ-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aubree",
    short: "cs",
    language: "Czech (Czech Republic)",
    text: "\nDobrý den, jmenuji se Aubree a budu dnes vaším vypravěčem.\nAudio Anything je bezplatný software pro převod textu na řeč, který používá\nGenerování umělé inteligence a strojového učení\nautentické lidské hlasy. Podporuje převod textu na řeč\n200 hlasů a více než 40 jazyků!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/cs-CZ-Standard-A.mp3?generation=1620951555206004&alt=media",
  },
  {
    languageCodes: ["el-GR"],
    name: "el-GR-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jade",
    short: "el",
    language: "Greek (Greece)",
    text: "\nΓεια σας, το όνομά μου είναι Jade και θα είμαι ο αφηγητής σας σήμερα.\nΤο Audio Anything είναι ένα δωρεάν λογισμικό κειμένου σε ομιλία που χρησιμοποιεί\nΤεχνητή νοημοσύνη και μηχανική μάθηση για δημιουργία\nαυθεντικές ανθρώπινες φωνές. Υποστηρίζει κείμενο σε ομιλία\n200 φωνές και πάνω από 40 γλώσσες!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/el-GR-Standard-A.mp3?generation=1620951557928546&alt=media",
  },
  {
    languageCodes: ["pt-BR"],
    name: "pt-BR-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 22050,
    humanName: "Katherine",
    short: "pt",
    language: "Portuguese (Brazil)",
    text: "\nOlá, meu nome é Katherine e hoje serei sua narradora.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-BR-Standard-A.mp3?generation=1620951560703582&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isabelle",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola mi nombre es Isabelle y hoy seré tu narradora.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Standard-A.mp3?generation=1620951563580629&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Xavier",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola, mi nombre es Xavier y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Standard-B.mp3?generation=1620951566208466&alt=media",
  },
  {
    languageCodes: ["es-US"],
    name: "es-US-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jose",
    short: "es",
    language: "Spanish (US)",
    text: "\nHola mi nombre es Jose y hoy seré tu narrador.\nAudio Anything es un software gratuito de texto a voz que utiliza\nInteligencia artificial y aprendizaje automático para generar\nauténticas voces humanas. Es compatible con Text to Speech en más de\n¡200 voces y más de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/es-US-Standard-C.mp3?generation=1620951568946580&alt=media",
  },
  {
    languageCodes: ["af-ZA"],
    name: "af-ZA-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Natalia",
    short: "af",
    language: "Afrikaans (South Africa)",
    text: "\nHallo my naam is Natalia en ek sal vandag u verteller wees.\nAudio Anything is 'n gratis teks-na-spraak-sagteware wat gebruik word\nKunsmatige intelligensie en masjienleer om te genereer\noutentieke mensestemme. Dit ondersteun teks na spraak in meer as\n200 stemme en meer as 40 tale!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/af-ZA-Standard-A.mp3?generation=1620951571711335&alt=media",
  },
  {
    languageCodes: ["bg-BG"],
    name: "bg-bg-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Raelynn",
    short: "bg",
    language: "Bulgarian (Bulgaria)",
    text: "\nЗдравейте, казвам се Raelynn и днес ще ви разказвам.\nAudio Anything е безплатен софтуер за преобразуване на текст в реч, който използва\nИзкуствен интелект и машинно обучение за генериране\nавтентични човешки гласове. Той поддържа текст в реч в над\n200 гласа и над 40 езика!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/bg-bg-Standard-A.mp3?generation=1620951574537823&alt=media",
  },
  {
    languageCodes: ["hu-HU"],
    name: "hu-HU-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Maria",
    short: "hu",
    language: "Hungarian (Hungary)",
    text: "\nHelló, a nevem Maria, és ma leszek a narrátorod.\nAz Audio Anything egy ingyenes szövegfelolvasó szoftver, amelyet használ\nMesterséges intelligencia és gépi tanulás generálni\nhiteles emberi hangok. Támogatja a szövegfelolvasást\n200 hang és több mint 40 nyelv!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hu-HU-Standard-A.mp3?generation=1620951577241940&alt=media",
  },
  {
    languageCodes: ["lv-LV"],
    name: "lv-lv-Standard-A",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jace",
    short: "lv",
    language: "Latvian (Latvia)",
    text: "\nSveiki, mani sauc Jace, un es šodien būšu tavs stāstītājs.\nAudio Anything ir bezmaksas teksta pārveidošanai runā programmatūra, kas tiek izmantota\nMākslīgais intelekts un mašīnmācīšanās ģenerēt\nautentiskas cilvēku balsis. Tas atbalsta teksta pārvēršanu runā\n200 balsis un vairāk nekā 40 valodas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/lv-lv-Standard-A.mp3?generation=1620951580126644&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 22050,
    humanName: "Athena",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Atena i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Standard-E.mp3?generation=1620951582789989&alt=media",
  },
  {
    languageCodes: ["ro-RO"],
    name: "ro-RO-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ximena",
    short: "ro",
    language: "Romanian (Romania)",
    text: "\nBună ziua, numele meu este Ximena și voi fi naratorul tău astăzi.\nAudio Anything este un software gratuit de tip text to speech care folosește\nInteligență artificială și învățare automată pentru a genera\nvoci umane autentice. Acceptă text în vorbire peste\n200 de voci și peste 40 de limbi!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ro-RO-Standard-A.mp3?generation=1620951585565648&alt=media",
  },
  {
    languageCodes: ["sk-SK"],
    name: "sk-SK-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Arya",
    short: "sk",
    language: "Slovak (Slovakia)",
    text: "\nDobrý deň, volám sa Arya a budem dnes vaším rozprávačom.\nAudio Anything je bezplatný softvér na prevod textu na reč, ktorý používa\nUmelá inteligencia a strojové učenie sa generovať\nautentické ľudské hlasy. Podporuje prevod textu na reč\n200 hlasov a viac ako 40 jazykov!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/sk-SK-Standard-A.mp3?generation=1620951588216688&alt=media",
  },
  {
    languageCodes: ["sr-RS"],
    name: "sr-rs-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Leilani",
    short: "sr",
    language: "Serbian (Cyrillic)",
    text: "\nПоздрав, моје име је Леилани и данас ћу бити ваш приповедач.\nАудио Анитхинг је бесплатни софтвер за претварање текста у говор који користи\nВештачка интелигенција и машинско учење за генерисање\nаутентични људски гласови. Подржава претварање текста у говор\n200 гласова и преко 40 језика!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/sr-rs-Standard-A.mp3?generation=1620951590985794&alt=media",
  },
  {
    languageCodes: ["uk-UA"],
    name: "uk-UA-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Taylor",
    short: "uk",
    language: "Ukrainian (Ukraine)",
    text: "\nПривіт, мене звати Тейлор, і я сьогодні буду вашим оповідачем.\nAudio Anything - це безкоштовне програмне забезпечення для перетворення тексту в мову, яке використовує\nШтучний інтелект та машинне навчання для створення\nсправжні людські голоси. Він підтримує перетворення тексту в мову\n200 голосів і понад 40 мов!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/uk-UA-Standard-A.mp3?generation=1620951593763125&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Faith",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Faith i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Standard-A.mp3?generation=1620951596500767&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jameson",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nCześć, nazywam się Jameson i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Standard-B.mp3?generation=1620951599283632&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Leonardo",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Leonardo i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Standard-C.mp3?generation=1620951602114587&alt=media",
  },
  {
    languageCodes: ["pl-PL"],
    name: "pl-PL-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Rose",
    short: "pl",
    language: "Polish (Poland)",
    text: "\nWitam, nazywam się Rose i będę dzisiaj waszym narratorem.\nAudio Anything to darmowe oprogramowanie do zamiany tekstu na mowę, które używa\nSztuczna inteligencja i uczenie maszynowe do generowania\nautentyczne ludzkie głosy. Obsługuje tekst na mowę w ponad\n200 głosów i ponad 40 języków!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pl-PL-Standard-D.mp3?generation=1620951604902027&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Bryson",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Bryson ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Standard-B.mp3?generation=1620951607548917&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kylie",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Kylie ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Standard-C.mp3?generation=1620951610302633&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alexandra",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Alexandra ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Standard-D.mp3?generation=1620951613573076&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Standard-E",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Axel",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Axel ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Standard-E.mp3?generation=1620951616170013&alt=media",
  },
  {
    languageCodes: ["tr-TR"],
    name: "tr-TR-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Mary",
    short: "tr",
    language: "Turkish (Turkey)",
    text: "\nMerhaba benim adım Mary ve bugün anlatıcınız olacağım.\nAudio Anything kullanan ücretsiz bir metin okuma yazılımıdır.\nYapay Zeka ve Makine Öğrenimi oluşturmak için\notantik insan sesleri. Metinden Konuşmaya desteği\n200 ses ve 40'tan fazla dil!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/tr-TR-Standard-A.mp3?generation=1620951618812523&alt=media",
  },
  {
    languageCodes: ["th-TH"],
    name: "th-TH-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 22050,
    humanName: "Margaret",
    short: "th",
    language: "Thai (Thailand)",
    text: "\nสวัสดีฉันชื่อมาร์กาเร็ตและฉันจะเป็นผู้บรรยายของคุณในวันนี้\nAudio Anything เป็นซอฟต์แวร์ข้อความเป็นคำพูดฟรีที่ใช้\nปัญญาประดิษฐ์และการเรียนรู้ของเครื่องเพื่อสร้าง\nเสียงของมนุษย์แท้ๆ รองรับ Text to Speech มากกว่า\n200 เสียงและมากกว่า 40 ภาษา!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/th-TH-Standard-A.mp3?generation=1620951621716632&alt=media",
  },
  {
    languageCodes: ["bn-IN"],
    name: "bn-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lyla",
    short: "bn",
    language: "Bengali (India)",
    text: "\nহ্যালো আমার নাম লায়লা এবং আমি আজ আপনার বর্ণনাকারী হব।\nঅডিও যে কোনও কিছুই স্পিচ সফ্টওয়্যারগুলির জন্য নিখরচায় পাঠ্য\nকৃত্রিম বুদ্ধিমত্তা এবং মেশিন লার্নিং উত্পন্ন করতে\nখাঁটি মানব কণ্ঠস্বর। এটি ওভারে পাঠ্য থেকে স্পিচ সমর্থন করে\n200 ভয়েস এবং 40 এরও বেশি ভাষা!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/bn-IN-Standard-A.mp3?generation=1620951624693433&alt=media",
  },
  {
    languageCodes: ["bn-IN"],
    name: "bn-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Everett",
    short: "bn",
    language: "Bengali (India)",
    text: "\nহ্যালো আমার নাম এভারেট এবং আমি আজ আপনার বর্ণনাকারী হব।\nঅডিও যে কোনও কিছুই স্পিচ সফ্টওয়্যারগুলির জন্য নিখরচায় পাঠ্য\nকৃত্রিম বুদ্ধিমত্তা এবং মেশিন লার্নিং উত্পন্ন করতে\nখাঁটি মানব কণ্ঠস্বর। এটি ওভারে পাঠ্য থেকে স্পিচ সমর্থন করে\n200 ভয়েস এবং 40 এরও বেশি ভাষা!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/bn-IN-Standard-B.mp3?generation=1620951627500496&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ashley",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Ashley and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Standard-D.mp3?generation=1620951630801420&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Amaya",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Amaya and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Standard-A.mp3?generation=1620951633632552&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Parker",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Parker and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Standard-B.mp3?generation=1620951636426967&alt=media",
  },
  {
    languageCodes: ["en-IN"],
    name: "en-IN-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kayden",
    short: "en",
    language: "English (India)",
    text: "\nHello my name is Kayden and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-IN-Standard-C.mp3?generation=1620951639483835&alt=media",
  },
  {
    languageCodes: ["gu-IN"],
    name: "gu-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eliza",
    short: "gu",
    language: "Gujarati (India)",
    text: "\nનમસ્તે મારું નામ એલિઝા છે અને હું આજે તમારી વિવેચક બનીશ.\nAudioડિઓ કંઈપણ એ સ્પીચ સ softwareફ્ટવેરનો મફત ટેક્સ્ટ છે જેનો ઉપયોગ કરે છે\nકૃત્રિમ બુદ્ધિ અને ઉત્પાદન શીખવા માટે મશીન\nઅધિકૃત માનવ અવાજો. તે ઓવરમાં ટેક્સ્ટ ટુ સ્પીચને સપોર્ટ કરે છે\n200 અવાજો અને 40 થી વધુ ભાષાઓ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/gu-IN-Standard-A.mp3?generation=1620951642453371&alt=media",
  },
  {
    languageCodes: ["gu-IN"],
    name: "gu-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Miles",
    short: "gu",
    language: "Gujarati (India)",
    text: "\nનમસ્તે મારું નામ માઇલ્સ છે અને હું આજે તમારો નેરેટર બનીશ.\nAudioડિઓ કંઈપણ એ સ્પીચ સ softwareફ્ટવેરનો મફત ટેક્સ્ટ છે જેનો ઉપયોગ કરે છે\nકૃત્રિમ બુદ્ધિ અને ઉત્પાદન શીખવા માટે મશીન\nઅધિકૃત માનવ અવાજો. તે ઓવરમાં ટેક્સ્ટ ટુ સ્પીચને સપોર્ટ કરે છે\n200 અવાજો અને 40 થી વધુ ભાષાઓ!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/gu-IN-Standard-B.mp3?generation=1620951645426105&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Brianna",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्ते मेरा नाम ब्रायन है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Standard-D.mp3?generation=1620951648552802&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Bailey",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्कार मेरा नाम बेली है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Standard-A.mp3?generation=1620951651627855&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Sawyer",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्कार मेरा नाम सवाई है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Standard-B.mp3?generation=1620951654778049&alt=media",
  },
  {
    languageCodes: ["hi-IN"],
    name: "hi-IN-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jason",
    short: "hi",
    language: "Hindi (India)",
    text: "\nनमस्ते मेरा नाम जेसन है और मैं आज आपका कथावाचक बनूंगा।\nऑडियो कुछ भी भाषण सॉफ्टवेयर का उपयोग करने के लिए एक स्वतंत्र पाठ है\nआर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग उत्पन्न करने के लिए\nप्रामाणिक मानव आवाज। यह ओवर में टेक्स्ट टू स्पीच का समर्थन करता है\n200 आवाजें और 40 से अधिक भाषाएं!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/hi-IN-Standard-C.mp3?generation=1620951657917987&alt=media",
  },
  {
    languageCodes: ["kn-IN"],
    name: "kn-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Andrea",
    short: "kn",
    language: "Kannada (India)",
    text: "\nಹಲೋ ನನ್ನ ಹೆಸರು ಆಂಡ್ರಿಯಾ ಮತ್ತು ನಾನು ಇಂದು ನಿಮ್ಮ ನಿರೂಪಕನಾಗುತ್ತೇನೆ.\nಆಡಿಯೋ ಎನಿಥಿಂಗ್ ಎನ್ನುವುದು ಸ್ಪೀಚ್ ಸಾಫ್ಟ್‌ವೇರ್‌ಗೆ ಬಳಸುವ ಉಚಿತ ಪಠ್ಯವಾಗಿದೆ\nಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಮತ್ತು ಉತ್ಪಾದಿಸಲು ಯಂತ್ರ ಕಲಿಕೆ\nಅಧಿಕೃತ ಮಾನವ ಧ್ವನಿಗಳು. ಇದು ಪಠ್ಯದಿಂದ ಭಾಷಣವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ\n200 ಧ್ವನಿಗಳು ಮತ್ತು 40 ಕ್ಕೂ ಹೆಚ್ಚು ಭಾಷೆಗಳು!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/kn-IN-Standard-A.mp3?generation=1620951660839511&alt=media",
  },
  {
    languageCodes: ["kn-IN"],
    name: "kn-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Declan",
    short: "kn",
    language: "Kannada (India)",
    text: "\nಹಲೋ ನನ್ನ ಹೆಸರು ಡೆಕ್ಲಾನ್ ಮತ್ತು ನಾನು ಇಂದು ನಿಮ್ಮ ನಿರೂಪಕನಾಗುತ್ತೇನೆ.\nಆಡಿಯೋ ಎನಿಥಿಂಗ್ ಎನ್ನುವುದು ಸ್ಪೀಚ್ ಸಾಫ್ಟ್‌ವೇರ್‌ಗೆ ಬಳಸುವ ಉಚಿತ ಪಠ್ಯವಾಗಿದೆ\nಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಮತ್ತು ಉತ್ಪಾದಿಸಲು ಯಂತ್ರ ಕಲಿಕೆ\nಅಧಿಕೃತ ಮಾನವ ಧ್ವನಿಗಳು. ಇದು ಪಠ್ಯದಿಂದ ಭಾಷಣವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ\n200 ಧ್ವನಿಗಳು ಮತ್ತು 40 ಕ್ಕೂ ಹೆಚ್ಚು ಭಾಷೆಗಳು!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/kn-IN-Standard-B.mp3?generation=1620951663939697&alt=media",
  },
  {
    languageCodes: ["ml-IN"],
    name: "ml-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Khloe",
    short: "ml",
    language: "Malayalam (India)",
    text: "\nഹലോ എന്റെ പേര് ക്ലോയി, ഞാൻ ഇന്ന് നിങ്ങളുടെ ആഖ്യാതാവ് ആയിരിക്കും.\nസംഭാഷണ സോഫ്റ്റ്വെയറിലേക്കുള്ള ഒരു സ text ജന്യ വാചകമാണ് ഓഡിയോ എന്തും\nസൃഷ്ടിക്കുന്നതിനുള്ള കൃത്രിമ ഇന്റലിജൻസ്, മെഷീൻ ലേണിംഗ്\nആധികാരിക മനുഷ്യ ശബ്ദങ്ങൾ. ഇത് ടെക്സ്റ്റ് ടു സ്പീച്ച് ഓവർ പിന്തുണയ്ക്കുന്നു\n200 ശബ്ദങ്ങളും 40 ലധികം ഭാഷകളും!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ml-IN-Standard-A.mp3?generation=1620951666660746&alt=media",
  },
  {
    languageCodes: ["ml-IN"],
    name: "ml-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Weston",
    short: "ml",
    language: "Malayalam (India)",
    text: "\nഹലോ എന്റെ പേര് വെസ്റ്റൺ, ഞാൻ ഇന്ന് നിങ്ങളുടെ ആഖ്യാതാവ് ആയിരിക്കും.\nസംഭാഷണ സോഫ്റ്റ്വെയറിലേക്കുള്ള ഒരു സ text ജന്യ വാചകമാണ് ഓഡിയോ എന്തും\nസൃഷ്ടിക്കുന്നതിനുള്ള കൃത്രിമ ഇന്റലിജൻസ്, മെഷീൻ ലേണിംഗ്\nആധികാരിക മനുഷ്യ ശബ്ദങ്ങൾ. ഇത് ടെക്സ്റ്റ് ടു സ്പീച്ച് ഓവർ പിന്തുണയ്ക്കുന്നു\n200 ശബ്ദങ്ങളും 40 ലധികം ഭാഷകളും!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ml-IN-Standard-B.mp3?generation=1620951669382117&alt=media",
  },
  {
    languageCodes: ["ta-IN"],
    name: "ta-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Jasmine",
    short: "ta",
    language: "Tamil (India)",
    text: "\nவணக்கம் என் பெயர் மல்லிகை, நான் இன்று உங்கள் கதைசொல்லியாக இருப்பேன்.\nஆடியோ எதையும் பேச்சு மென்பொருளுக்கு இலவச உரை\nஉருவாக்க செயற்கை நுண்ணறிவு மற்றும் இயந்திர கற்றல்\nஉண்மையான மனித குரல்கள். இது உரையில் இருந்து பேச்சுக்கு துணைபுரிகிறது\n200 குரல்கள் மற்றும் 40 க்கும் மேற்பட்ட மொழிகள்!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ta-IN-Standard-A.mp3?generation=1620951672085526&alt=media",
  },
  {
    languageCodes: ["ta-IN"],
    name: "ta-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Micah",
    short: "ta",
    language: "Tamil (India)",
    text: "\nவணக்கம் என் பெயர் மீகா, நான் இன்று உங்கள் கதைசொல்லியாக இருப்பேன்.\nஆடியோ எதையும் பேச்சு மென்பொருளுக்கு இலவச உரை\nஉருவாக்க செயற்கை நுண்ணறிவு மற்றும் இயந்திர கற்றல்\nஉண்மையான மனித குரல்கள். இது உரையில் இருந்து பேச்சுக்கு துணைபுரிகிறது\n200 குரல்கள் மற்றும் 40 க்கும் மேற்பட்ட மொழிகள்!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ta-IN-Standard-B.mp3?generation=1620951674820766&alt=media",
  },
  {
    languageCodes: ["te-IN"],
    name: "te-IN-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Melody",
    short: "te",
    language: "Telugu (India)",
    text: "\nహలో నా పేరు మెలోడీ మరియు నేను ఈ రోజు మీ కథకుడిగా ఉంటాను.\nఆడియో ఏదైనా మాట్లాడే స్పీచ్ సాఫ్ట్‌వేర్‌కు ఉచిత టెక్స్ట్\nకృత్రిమ మేధస్సు మరియు యంత్ర అభ్యాసం\nప్రామాణికమైన మానవ స్వరాలు. ఇది టెక్స్ట్ టు స్పీచ్‌కు మద్దతు ఇస్తుంది\n200 గాత్రాలు మరియు 40 కి పైగా భాషలు!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/te-IN-Standard-A.mp3?generation=1620951677721626&alt=media",
  },
  {
    languageCodes: ["te-IN"],
    name: "te-IN-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ayden",
    short: "te",
    language: "Telugu (India)",
    text: "\nహలో నా పేరు ఐడెన్ మరియు నేను ఈ రోజు మీ కథకుడు అవుతాను.\nఆడియో ఏదైనా మాట్లాడే స్పీచ్ సాఫ్ట్‌వేర్‌కు ఉచిత టెక్స్ట్\nకృత్రిమ మేధస్సు మరియు యంత్ర అభ్యాసం\nప్రామాణికమైన మానవ స్వరాలు. ఇది టెక్స్ట్ టు స్పీచ్‌కు మద్దతు ఇస్తుంది\n200 గాత్రాలు మరియు 40 కి పైగా భాషలు!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/te-IN-Standard-B.mp3?generation=1620951680582188&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 22050,
    humanName: "Iris",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Iris, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Standard-A.mp3?generation=1620951683212386&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Wesley",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Wesley, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Standard-C.mp3?generation=1620951685887203&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Isabel",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Isabel, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Standard-D.mp3?generation=1620951688488537&alt=media",
  },
  {
    languageCodes: ["da-DK"],
    name: "da-DK-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Norah",
    short: "da",
    language: "Danish (Denmark)",
    text: "\nHej mit navn er Norah, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-software, der bruger\nKunstig intelligens og maskinlæring at generere\nautentiske menneskelige stemmer. Det understøtter Tekst til tale i over\n200 stemmer og over 40 sprog!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/da-DK-Standard-E.mp3?generation=1620951691219213&alt=media",
  },
  {
    languageCodes: ["fi-FI"],
    name: "fi-FI-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Annabelle",
    short: "fi",
    language: "Finnish (Finland)",
    text: "\nHei, nimeni on Annabelle ja minä olen sinun kertojasi tänään.\nAudio Anything on ilmainen tekstistä puheeksi -ohjelmisto, joka käyttää\nTekoäly ja koneoppiminen tuottamaan\naitoja ihmisen ääniä. Se tukee teksti puheeksi -ohjelmaa\n200 ääntä ja yli 40 kieltä!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fi-FI-Standard-A.mp3?generation=1620951693856137&alt=media",
  },
  {
    languageCodes: ["is-IS"],
    name: "is-is-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Valeria",
    short: "is",
    language: "Icelandic (Iceland)",
    text: "\nHalló ég heiti Valeria og ég verð spámaður þinn í dag.\nAudio Anything er frjáls texti í talhugbúnað sem notar\nGervigreind og vélrænt nám til að búa til\nekta mannlegar raddir. Það styður Text to Speech í yfir\n200 raddir og yfir 40 tungumál!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/is-is-Standard-A.mp3?generation=1620951696703211&alt=media",
  },
  {
    languageCodes: ["sv-SE"],
    name: "sv-SE-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 22050,
    humanName: "Emerson",
    short: "sv",
    language: "Swedish (Sweden)",
    text: "\nHej jag heter Emerson och jag kommer att vara din narrator idag.\nAudio Anything är en fri-till-tal-programvara som använder\nArtificiell intelligens och maskininlärning att generera\nautentiska mänskliga röster. Den stöder Text to Speech över\n200 röster och över 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/sv-SE-Standard-A.mp3?generation=1620951699265259&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Adalyn",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Adalyn og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Standard-A.mp3?generation=1620951701912884&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Luca",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Luca, og jeg blir narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Standard-B.mp3?generation=1620951704651200&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ryleigh",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Ryleigh, og jeg vil være din narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Standard-C.mp3?generation=1620951707292953&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-NO-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Vincent",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Vincent, og jeg blir narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-NO-Standard-D.mp3?generation=1620951710005201&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-no-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Eden",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Eden, og jeg blir narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-no-Standard-E.mp3?generation=1620951712607597&alt=media",
  },
  {
    languageCodes: ["nb-NO"],
    name: "nb-no-Standard-E",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emersyn",
    short: "nb",
    language: "Norwegian (Norway)",
    text: "\nHei, jeg heter Emersyn og jeg vil være narrator i dag.\nAudio Anything er en fri tekst til tale-programvare som bruker\nKunstig intelligens og maskinlæring å generere\nautentiske menneskelige stemmer. Den støtter Tekst til tale i over\n200 stemmer og over 40 språk!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/nb-no-Standard-E.mp3?generation=1620951715229619&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Anastasia",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Anastasia e eu serei seu narrador hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Standard-A.mp3?generation=1620951717902475&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Damian",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Damian e serei seu narrador hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Standard-B.mp3?generation=1620951720688049&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Zachary",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Zachary e serei seu narrador hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Standard-C.mp3?generation=1620951723444049&alt=media",
  },
  {
    languageCodes: ["pt-PT"],
    name: "pt-PT-Standard-D",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kayla",
    short: "pt",
    language: "Portuguese (Portugal)",
    text: "\nOlá, meu nome é Kayla e serei sua narradora hoje.\nAudio Anything é um software de conversão de texto em voz gratuito que usa\nInteligência Artificial e Aprendizado de Máquina para gerar\nvozes humanas autênticas. Suporta Text to Speech em mais\n200 vozes e mais de 40 idiomas!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/pt-PT-Standard-D.mp3?generation=1620951726200785&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alyssa",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Alyssa et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Standard-A.mp3?generation=1620951728988582&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Silas",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Silas et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Standard-B.mp3?generation=1620951731689756&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Juliana",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Juliana et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Standard-C.mp3?generation=1620951734445601&alt=media",
  },
  {
    languageCodes: ["fr-FR"],
    name: "fr-FR-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Gavin",
    short: "fr",
    language: "French (France)",
    text: "\nBonjour, je m'appelle Gavin et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-FR-Standard-D.mp3?generation=1620951737283991&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-E",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Chase",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Chase und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-E.mp3?generation=1620951740025334&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Charlie",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Charlie und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-A.mp3?generation=1620951742911791&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kai",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Kai und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-B.mp3?generation=1620951745674889&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Esther",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Esther und ich werde heute Ihre Erzählerin sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-C.mp3?generation=1620951748446866&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Emmett",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Emmett und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-D.mp3?generation=1620951751186668&alt=media",
  },
  {
    languageCodes: ["de-DE"],
    name: "de-DE-Standard-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ariel",
    short: "de",
    language: "German (Germany)",
    text: "\nHallo, mein Name ist Ariel und ich werde heute Ihr Erzähler sein.\nAudio Anything ist eine freie Text-zu-Sprache-Software, die verwendet wird\nKünstliche Intelligenz und maschinelles Lernen zu generieren\nauthentische menschliche Stimmen. Es unterstützt Text to Speech in Over\n200 Stimmen und über 40 Sprachen!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/de-DE-Standard-F.mp3?generation=1620951753960240&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Cecilia",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Cecilia et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Standard-A.mp3?generation=1620951756711856&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Harrison",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Harrison et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Standard-B.mp3?generation=1620951759415587&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Valerie",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Valérie et je serai votre narratrice aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Standard-C.mp3?generation=1620951762170380&alt=media",
  },
  {
    languageCodes: ["fr-CA"],
    name: "fr-CA-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Nathaniel",
    short: "fr",
    language: "French (Canada)",
    text: "\nBonjour, je m'appelle Nathaniel et je serai votre narrateur aujourd'hui.\nAudio Anything est un logiciel de synthèse vocale gratuit qui utilise\nIntelligence artificielle et apprentissage automatique pour générer\ndes voix humaines authentiques. Il prend en charge la synthèse vocale dans plus\n200 voix et plus de 40 langues!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/fr-CA-Standard-D.mp3?generation=1620951765104829&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Standard-B",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Alina",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Alina e oggi sarò la tua narratrice.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Standard-B.mp3?generation=1620951767834872&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Standard-C",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Kingston",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Kingston e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Standard-C.mp3?generation=1620951770459521&alt=media",
  },
  {
    languageCodes: ["it-IT"],
    name: "it-IT-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Cole",
    short: "it",
    language: "Italian (Italy)",
    text: "\nCiao, mi chiamo Cole e oggi sarò il tuo narratore.\nAudio Anything è un software di sintesi vocale gratuito che utilizza\nIntelligenza artificiale e machine learning per generare\nautentiche voci umane. Supporta Text to Speech in oltre\n200 voci e oltre 40 lingue!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/it-IT-Standard-D.mp3?generation=1620951773022432&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Molly",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Molly and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Standard-A.mp3?generation=1620951775756721&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Tyler",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Tyler and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Standard-B.mp3?generation=1620951778597369&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Reese",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Reese and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Standard-C.mp3?generation=1620951781319687&alt=media",
  },
  {
    languageCodes: ["en-AU"],
    name: "en-AU-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Bennett",
    short: "en",
    language: "English (Australia)",
    text: "\nHello my name is Bennett and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-AU-Standard-D.mp3?generation=1620951783969046&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Standard-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Aliyah",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Aliyah and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Standard-A.mp3?generation=1620951786797281&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Standard-B",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Bentley",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Bentley and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Standard-B.mp3?generation=1620951789530279&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Standard-C",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Lilly",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Lilly and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Standard-C.mp3?generation=1620951792336595&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Standard-D",
    ssmlGender: "MALE",
    naturalSampleRateHertz: 24000,
    humanName: "Ryker",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Ryker and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Standard-D.mp3?generation=1620951795102210&alt=media",
  },
  {
    languageCodes: ["en-GB"],
    name: "en-GB-Standard-F",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Parker",
    short: "en",
    language: "English (UK)",
    text: "\nHello my name is Parker and I will be your narrarator today. \nAudio Anything is a free text to speech software that uses \nArtificial Intelligence and Machine Learning to generate \nauthentic human voices. It supports Text to Speech in over \n200 voices and over 40 languages!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/en-GB-Standard-F.mp3?generation=1620951797772336&alt=media",
  },
  {
    languageCodes: ["ro-RO"],
    name: "ro-RO-Wavenet-A",
    ssmlGender: "FEMALE",
    naturalSampleRateHertz: 24000,
    humanName: "Finley",
    short: "ro",
    language: "Romanian (Romania)",
    text: "\nBună ziua, numele meu este Finley și voi fi naratorul tău astăzi.\nAudio Anything este un software gratuit de tip text to speech care folosește\nInteligență artificială și învățare automată pentru a genera\nvoci umane autentice. Acceptă text în vorbire peste\n200 de voci și peste 40 de limbi!\n",
    url: "https://storage.googleapis.com/download/storage/v1/b/text_to_speech_googl_premium_voices/o/ro-RO-Wavenet-A.mp3?generation=1620951800539292&alt=media",
  },
];
